var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanimatorLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.24 141.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #838282;\n      }\n\n      .cls-2 {\n        fill: #f5f4f3;\n      }\n\n      .cls-3 {\n        fill: #454545;\n      }\n\n      .cls-4 {\n        fill: #ff9100;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #d26e00;\n      }\n\n      .cls-7 {\n        fill: #e1e1e1;\n      }\n\n      .cls-8 {\n        fill: #696767;\n      }\n\n      .cls-9 {\n        fill: #ffa403;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.9,30.7L72.37,3.29l16.47,27.41-16.47,27.41-16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.37,3.29h-33.75l-16.47,27.41h33.75L72.37,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.37,58.11l-16.47-27.41H22.15l16.47,27.41h33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.9,110.95l16.47-27.41,16.47,27.41-16.47,27.41-16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.37,83.54h-33.75l-16.47,27.41h33.75l16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.37,138.36l-16.47-27.41H22.15l16.47,27.41h33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M127.29,70.83l16.47-27.41,16.47,27.41-16.47,27.41-16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.77,43.42h-33.75l-16.47,27.41h33.75l16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.77,98.24l-16.47-27.41h-33.75l16.47,27.41h33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.58,27.41L120.05,0l16.47,27.41-16.47,27.41-16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120.05,0h-33.75l-16.47,27.41h33.75L120.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.05,54.82l-16.47-27.41h-33.75l16.47,27.41h33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.58,114.24l16.47-27.41,16.47,27.41-16.47,27.41-16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120.05,86.83h-33.75l-16.47,27.41h33.75l16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.05,141.65l-16.47-27.41h-33.75l16.47,27.41h33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.75,70.83l16.47-27.41,16.47,27.41-16.47,27.41-16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.22,43.42H16.47L0,70.83h33.75l16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.22,98.24l-16.47-27.41H0l16.47,27.41h33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.43,70.83l16.47-27.41,16.47,27.41-16.47,27.41-16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.9,43.42h-33.75l-16.47,27.41h33.75l16.47-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M97.9,98.24l-16.47-27.41h-33.75l16.47,27.41h33.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanimatorLogoColor);
export default __webpack_public_path__ + "static/media/planimator-logo-color.77091f592c1759abeb5a8608b3d854bf.svg";
export { ForwardRef as ReactComponent };